// extracted by mini-css-extract-plugin
module.exports = {"layout":"AuthLayout_layout__hNlHk","header":"AuthLayout_header__f1ETY","close-icon":"AuthLayout_close-icon__XbTfS"};